import { Button, Image, TextSize, Weight } from 'components'

import styled from 'styled-components'

/**
 * First section of the overview page
 */
export const OverViewSplash = styled.div`
  width: 100%;
  max-height: 1024px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 825px;
  padding: 0 85px;
  margin: 0 auto;
  height: 542px;
`

/**
 * The container, for padding from the wrapper (overviewsplash)
 */
export const SplashContainer = styled.div`
  padding: 60px 0;
`

/**
 * Container for the primary content, a flex container with two columns
 */
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

/**
 * Container for the primary content, a flex container with two columns
 */
export const ContentContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
`

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: flex-end;
`
/**
 * Styling for the spash H1
 */
export const OverviewTitle = styled.h1`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.8px;
  max-width: 352px;
  margin: 0;
`

export const SplashContentDescription = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
  max-width: 332px;
  opacity: 0.6;
`

export const SplashButton = styled(Button)`
  width: 152px;
`
export const SkeletonWrapper = styled.div`
  width: 100%;
`

export const SplashImage = styled(Image)`
  max-width: 470px;
  width: 100%;
  height: 300px;
`

/**
 * Styling for the spash H1
 */
export const Title = styled.h1`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.big};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.64px;
  margin: 0;
  width: 261px;
`

/**
 * Styling for the spash description
 */
export const Description = styled.span`
  color: ${({ theme }) => theme.primaryFontColor};
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
  opacity: 0.6;
  width: 280px;
`

export const Wrapper = styled.div<{ isLoading?: boolean }>`
  width: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: 0 auto;
  height: auto;
`

export const ImageContainer = styled.div`
  position: relative;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  @media (max-width: 1023px) {
    display: flex;
    justify-content: center;
  }
  img {
    position: absolute;
    right: -80px;
    top: -386px;
    width: 449px;
    @media (max-width: 1023px) {
      position: relative;
      max-width: 360px;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      width: fill-available;
    }
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const MobileSplashButton = styled(Button)`
  width: 152px;
  height: 40px;
`
